// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * An SVG icon component that renders the Microsoft logo.
 */
export function MicrosoftLogo(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
        <path fill="#f35325" d="M0 0h11v11H0z" />
        <path fill="#81bc06" d="M12 0h11v11H12z" />
        <path fill="#05a6f0" d="M0 12h11v11H0z" />
        <path fill="#ffba08" d="M12 12h11v11H12z" />
      </svg>
    </SvgIcon>
  );
}
